/* eslint-disable i18next/no-literal-string */
import React, { useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { ReactComponent as Title } from 'assets/images/general-landing/signup/title.svg';
import img1 from 'assets/images/general-landing/signup/1.png';
import img2 from 'assets/images/general-landing/signup/2.png';
import img3 from 'assets/images/general-landing/signup/3.png';
import img4 from 'assets/images/general-landing/signup/4.png';
import img5 from 'assets/images/general-landing/signup/5.png';
import img6 from 'assets/images/general-landing/signup/6.png';
import { useHistory } from 'react-router-dom';
import styles from './SignUp.module.scss';

export default function SignUp() {
  const containerRef = useRef(null);
  const history = useHistory();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.visible);
          }
        });
      },
      {
        threshold: 0.1,
      },
    );

    const images = containerRef.current.querySelectorAll(`.${styles.image}`);
    images.forEach((img) => observer.observe(img));

    return () => {
      images.forEach((img) => observer.unobserve(img));
    };
  }, []);

  return (
    <div className={styles.container} ref={containerRef}>
      <Title />
      <div className={styles.description}>
        <Button onClick={() => {
          history.push('/get-started');
        }}
        >
          Free signup now
        </Button>
        <div className={styles.descriptionText}>
          Our expert team crafts stunning, high-quality transformations that captivate buyers and boost your property appeal. Experience exceptional value and watch your listings shine!
        </div>
      </div>
      <img
        src={img1}
        alt="img1"
        className={`${styles.image} ${styles.image1}`}
      />
      <img
        src={img2}
        alt="img2"
        className={`${styles.image} ${styles.image2}`}
      />
      <img
        src={img3}
        alt="img3"
        className={`${styles.image} ${styles.image3}`}
      />
      <img
        src={img4}
        alt="img4"
        className={`${styles.image} ${styles.image4}`}
      />
      <img
        src={img5}
        alt="img5"
        className={`${styles.image} ${styles.image5}`}
      />
      <img
        src={img6}
        alt="img6"
        className={`${styles.image} ${styles.image6}`}
      />
    </div>
  );
}
